import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorBrandDark } from 'styles/layout/colors';
import IconUpload from 'components/icons/IconUpload';
import CtaLink from 'components/essentials/Cta/CtaLink';
const PDPProductDetailsLinkSection = t0 => {
  const $ = _c(7);
  const {
    children,
    dataXc,
    link
  } = t0;
  if (!link) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconUpload color={colorBrandDark} height={17} width={17} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <span>{children}</span>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dataXc || $[4] !== link || $[5] !== t2) {
    t3 = <div><CtaLink color="brand-light" data-xc={dataXc} download={true} size="sm" spacing="sm" styling="solid-button" to={link}>{t1}{t2}</CtaLink></div>;
    $[3] = dataXc;
    $[4] = link;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
PDPProductDetailsLinkSection.propTypes = {
  children: React.node,
  dataXc: PropTypes.string,
  link: PropTypes.string
};
export default PDPProductDetailsLinkSection;